import styled from 'styled-components';

const BaseImage = styled.img`
  width: ${({ width }) => width || 'auto'};
  padding: ${({ padding }) => padding || 'auto'};
`;

export default BaseImage;
